<template>
  <div class="home">
    <img :src="homeBg" alt="" />
    <!-- <div class="toSign">
      <button @click="goSign()">去报名</button>
    </div> -->
  </div>
</template>

<script>
import { getSignTotal } from "@/api/api";
export default {
  name: "home",
  data() {
    return {
      isStart: false,
      img: require("@/assets/home-top.jpg"),
      imgBottom: require("@/assets/home-bottom.png"),
      homeBg: require("@/assets/homebg.jpg"),
    };
  },
  created: function () {
    this.preload();
  },

  methods: {
    preload: function () {
      let image = new Image();
      image.src = this.img;
      image.onload = () => {
        this.isStart = true;
      };
    },

    goSign() {
      this.$router.push({ path: "/jbxx" });
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100vw;
  height: 100vh;
  img {
    width: 100%;
  }
  .toSign {
    width: 100%;
    height: 85px;
    position: relative;
    bottom: 180px;
    button {
      border: none;
      border-radius: 16px;
      color: white;
      width: 210px;
      height: 32px;
      font-size: 16px;
      background-color: rgba(58, 141, 254, 1);
      position: absolute;
      top: 30px;
      left: 22%;
    }
  }
}
@keyframes show {
  0% {
    transform: scale(0);
  }

  // 50% {
  //   transform: scale(0.5);
  // }

  100% {
    transform: scale(1);
  }
}
</style>
